import { render, staticRenderFns } from "./splashscreen.vue?vue&type=template&id=213a5906"
import script from "./splashscreen.vue?vue&type=script&lang=js"
export * from "./splashscreen.vue?vue&type=script&lang=js"
import style0 from "./splashscreen.vue?vue&type=style&index=0&id=213a5906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports